module.exports = __webpack_public_path__ + "img/samsung-galaxy-a5.9a7b3b90.jpg";